import React from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import { pluck } from 'underscore';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import AssetAssociationsGroups from './assetAssociationsGroups';
import SinglePicker from '../common/controls/singlePicker';
import Icon from '../common/containers/icon';
import { changeItemWithConfirm, removeItemWithConfirm } from '../common/classes/handleItemWithConfirm';
const AssetAssociationsFacilities = ({
  areaList,
  facList,
  grpList,
  onChange,
  facilities
}) => {
  const handleAddDefaultGroup = index => {
    const groups = JSON.parse(JSON.stringify(facilities[index].groups));
    const newGroup = {
      id: null,
      areas: []
    };
    groups.push(newGroup);
    onChange(`facilities[${index}]/groups`, groups);
  };
  const handleChangeGroup = (index, name, value) => onChange(`facilities[${index}]/${name}`, value);
  const handleChangeFacility = (index, value) => {
    const updatedFacility = {
      id: value,
      groups: []
    };
    onChange(`facilities[${index}]`, updatedFacility);
  };
  const confirmOnChangeFields = ['groups'];
  const handleChange = (index, value) => changeItemWithConfirm(facilities[index], 'Facility (All associated groups and areas for this facility will be removed)', confirmOnChangeFields, handleChangeFacility.bind(null, index, value));
  const handleRemoveFacility = index => {
    const newFacilities = JSON.parse(JSON.stringify(facilities));
    newFacilities.splice(index, 1);
    onChange('facilities', newFacilities);
  };
  const confirmOnRemoveFields = ['id'];
  const handleRemove = index => removeItemWithConfirm(facilities[index], 'Facility (and nested Groups and Areas)', confirmOnRemoveFields, handleRemoveFacility.bind(null, index));
  const usedFacilities = pluck(facilities, 'id');
  return /*#__PURE__*/React.createElement("div", null, facilities.map((facility, index) => {
    const facOptions = facList.filter(fac => fac.id === facility.id || !usedFacilities.includes(fac.id));
    return /*#__PURE__*/React.createElement("div", {
      key: facility.id || uuidV4(),
      className: `t-aaf-${index}`
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 8,
        offset: 1
      }
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Associated Facility",
      onChange: value => handleChange(index, value),
      options: facOptions,
      placeholder: "Select...",
      value: facility.id,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: () => handleRemove(index),
      className: "float-md-right form-control t-aaf-remove-facility tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "trash"
    }), " Remove Facility"))), /*#__PURE__*/React.createElement(AssetAssociationsGroups, {
      areaList: areaList,
      groups: facility.groups,
      grpList: grpList.filter(grp => grp.facilityID === facility.id),
      onChange: (name, value) => handleChangeGroup(index, name, value)
    }), /*#__PURE__*/React.createElement(Row, {
      style: {
        marginBottom: '15px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: () => handleAddDefaultGroup(index),
      className: "float-md-right form-control t-aaf-add-group tqc-control",
      disabled: facility.id === null
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Group"))));
  }));
};
AssetAssociationsFacilities.propTypes = {
  areaList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  facilities: PropTypes.arrayOf(PropTypes.shape({
    groups: PropTypes.arrayOf(PropTypes.shape({}))
  })).isRequired,
  facList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  grpList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default AssetAssociationsFacilities;